import { useEffect, useRef } from "react";

/**
 * Scalar-powered interactive OpenAPI playground.
 *
 * Uses Scalar's standalone CDN script rather than `@scalar/api-reference-react`
 * — the React wrapper at 0.3.x reads `React.__SECRET_INTERNALS.ReactCurrentOwner`
 * which React 19 removed, so it throws on load. The standalone script is
 * React-version-agnostic and renders itself into the mount point.
 *
 * Spec lives at /schemas/hub-openapi.yaml so partners can also consume
 * it with their own codegen tooling (openapi-typescript, etc.).
 */
export function PlaygroundPage() {
  const mountedRef = useRef(false);

  useEffect(() => {
    if (mountedRef.current) return;
    mountedRef.current = true;

    // Install the spec config for Scalar's bootstrapper.
    const configScript = document.createElement("script");
    configScript.id = "api-reference";
    configScript.setAttribute("data-url", "/schemas/hub-openapi.yaml");
    configScript.setAttribute(
      "data-configuration",
      JSON.stringify({
        theme: "default",
        layout: "modern",
        hideDownloadButton: false,
      }),
    );
    document.getElementById("scalar-mount")?.appendChild(configScript);

    // Then load Scalar's bundle; it hydrates the #api-reference element.
    const scalar = document.createElement("script");
    scalar.src = "https://cdn.jsdelivr.net/npm/@scalar/api-reference";
    scalar.async = true;
    document.body.appendChild(scalar);

    return () => {
      // Clean up on unmount so navigating back + forth doesn't stack scripts.
      scalar.remove();
      configScript.remove();
    };
  }, []);

  return (
    <div className="-mx-6 -my-10">
      <div id="scalar-mount" className="min-h-[80vh]" />
    </div>
  );
}
